import { Grid as MantineGrid } from '@mantine/core'
import { GridProps } from './grid.types'

export const Grid = ({ ...props }: GridProps) => <MantineGrid {...props} />

Grid.Col = MantineGrid.Col
